import {useCallback, useEffect, useState} from "react";
import {Api, ApiError, CallbackHandler, RequestHeaders, ResponseWithBody} from "../api/api";
import {useStoreSelector} from "./redux/useStoreSelector";
import {SuperAgentRequest} from "superagent";
// @ts-ignore
import Throttle from 'superagent-throttle';
import * as request from "superagent";
import {dispatcher} from "../store";
import {useNotify} from "./system/useNotify";

const throttle = new Throttle({
  active: true,     // set false to pause queue
  rate: 10,          // how many requests can be sent every `ratePer`
  ratePer: 100,   // number of ms in which `rate` requests may be sent
  concurrent: 5     // how many requests can be sent concurrently
})

const baseURL = process.env.REACT_APP_GATEWAY_BASE_URL || ''
const defaultApi: Api = new Api(baseURL);

export function useApi() {
  const profile = useStoreSelector( state => state.user.profile),
    [api, setApi] = useState<Api>(defaultApi),
    [isAuth, setAuth] = useState(false),
    {addNotify} = useNotify();

  const headerHandler = useCallback((token?: string) => (headers: RequestHeaders): RequestHeaders => {
    if (token) {
      return {
        ...headers,
        'Authorization': token
      }
    } else {
      return headers
    }
  }, [])

  const requestHandler = useCallback((request: SuperAgentRequest) => {
    return request.use(throttle.plugin())
  }, [])

  const errorHandler: CallbackHandler = useCallback((err: any, res ? : request.Response) => {
    if (err?.status === 401) {
      if (isAuth) {
        addNotify('warning', 'Token expired')
      } else {
        addNotify('warning', 'Password is Incorrect')
      }
      dispatcher.user.logout()
      setAuth(false)
    } else if (err?.status === 403) {
      addNotify("error", "Error", 'Forbidden');
    } else if (err?.status === 400) {
      const resError = err as ResponseWithBody<400, ApiError>;
      addNotify("error", "Error", resError.body?.messages?.join("\n"));
    } else if (err?.status === 422) {
      addNotify("error", "Error", err?.response?.body?.message || 'Unprocessable Entity');
    } else if (err?.status === 404) {
      // Don't set backend offline for HTTP 404
    } else {
      dispatcher.system.setBackendOnline(false);
    }
  }, [isAuth, addNotify])

  useEffect(() => {
    const api = new Api(baseURL)
    api.setConfigureRequestHandler(requestHandler)
    api.addErrorHandler(errorHandler)
    setApi(api)
    if (profile && profile.jwtToken) {
      api.setRequestHeadersHandler(headerHandler(profile.jwtToken))
      setAuth(true)
    } else {
      api.setRequestHeadersHandler(headerHandler())
      setAuth(false)
    }
    dispatcher.system.setBackendOnline(true);
  }, [errorHandler, headerHandler, profile, requestHandler])

  return {api, isAuth}
}
